import styled from '@emotion/styled';
import Check from '@material-ui/icons/Check';
import { spacing, typography } from '$variables/theme';
import COLORS from '$variables/colors';

export const ModalContent = styled.div`
  padding: 0 ${spacing.xLarge} ${spacing.xLarge};
  text-align: center;
  line-height: 20px;
`;

export const Icon = styled.span`
  margin-left: ${spacing.xSmall};
  font-size: 12px;
`;

export const StyledCheck = styled(Check)`
  font-size: 20px;
  margin-left: ${spacing.xSmall};
  color: ${COLORS.green} !important;
`;

export const Bold = styled.span`
  font-weight: ${typography.fontWeightBold};
  margin-left: ${spacing.xxSmall};
  margin-right: ${spacing.xxSmall};
`;
